/* UMOJA bronze page: gallery and full screen, add to cart, sticky bar, the turn, workshop carousel, workshop film, reveal. */
(function(){
  const root = document.querySelector('[data-ubz]');
  if (!root) return;
  const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const variant = JSON.parse($('[data-ubz-variant]').textContent);
  const lock = on => document.documentElement.classList.toggle('upp-lock', on);

  /* gallery */
  const main = $('[data-upp-main]'), slides = $$('.upp__slide'), thumbs = $$('[data-upp-thumb]'), thumbRow = $('.upp__thumbs');
  thumbs.forEach(t => t.addEventListener('click', () => main.scrollTo({left: +t.dataset.uppThumb * main.clientWidth, behavior: 'smooth'})));
  let raf;
  main.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      thumbs.forEach((t, k) => t.classList.toggle('on', k === i));
      const a = thumbs[i];
      if (a && thumbRow){ const l = a.offsetLeft - thumbRow.offsetLeft; if (l < thumbRow.scrollLeft || l + a.offsetWidth > thumbRow.scrollLeft + thumbRow.clientWidth) thumbRow.scrollTo({left: l - 12, behavior: 'smooth'}); }
    });
  }, {passive: true});

  /* full screen */
  const lb = $('[data-upp-lb]'), track = $('[data-upp-lb-track]');
  slides.forEach(sl => sl.addEventListener('click', () => {
    lb.hidden = false; lock(true);
    requestAnimationFrame(() => { track.scrollLeft = track.clientWidth * (+sl.dataset.uppZoom); });
  }));
  const closeLb = () => { lb.hidden = true; lock(false); };
  $('[data-upp-lb-close]').addEventListener('click', closeLb);
  addEventListener('keydown', e => { if (e.key === 'Escape' && !lb.hidden) closeLb(); });

  /* add to cart: the cart drawer opens on its own */
  const form = document.getElementById('uppForm'), addBtn = $('[data-upp-add]'), msg = $('[data-upp-msg]');
  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (!variant.available) return;
    addBtn.disabled = true; msg.textContent = '';
    try {
      const r = await fetch(ROOT + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({items:[{id: variant.id, quantity: 1}]})});
      if (!r.ok){ const j = await r.json().catch(() => ({})); msg.textContent = j.description || 'This piece is not available right now.'; }
    } catch(x){ msg.textContent = 'Something went wrong. Please try again.'; }
    addBtn.disabled = !variant.available;
  });

  /* sticky bar on phones once the main button is out of view */
  const bar = $('[data-upp-bar]');
  if ('IntersectionObserver' in window){
    new IntersectionObserver(([en]) => { const show = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('on', show); bar.setAttribute('aria-hidden', !show); }).observe(addBtn);
  }
  $('[data-upp-bar-add]').addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : addBtn.click());

  /* workshop carousel: arrows and a gold progress line */
  $$('[data-ubz-car]').forEach(car => {
    const row = car.querySelector('[data-ubz-row]'), fill = car.querySelector('[data-ubz-bar]');
    const step = () => { const s = row.querySelector('.sl'); return s ? s.getBoundingClientRect().width + 14 : row.clientWidth; };
    car.querySelector('[data-ubz-prev]').addEventListener('click', () => row.scrollBy({left: -step(), behavior: 'smooth'}));
    car.querySelector('[data-ubz-next]').addEventListener('click', () => row.scrollBy({left: step(), behavior: 'smooth'}));
    const draw = () => {
      const max = row.scrollWidth - row.clientWidth, w = Math.min(1, row.clientWidth / row.scrollWidth);
      fill.style.width = (w * 100) + '%';
      fill.style.transform = 'translateX(' + (max > 0 ? (row.scrollLeft / max) * ((1 - w) / w) * 100 : 0) + '%)';
    };
    row.addEventListener('scroll', () => requestAnimationFrame(draw), {passive: true});
    addEventListener('resize', draw);
    draw();
  });

  /* workshop film: a tap swaps the still for the YouTube player, which starts right away; nothing loads from YouTube before */
  $$('[data-ubz-film]').forEach(f => {
    const still = f.querySelector('.ph');
    still.addEventListener('click', () => {
      const box = document.createElement('div'), ifr = document.createElement('iframe');
      box.className = 'ph on';
      ifr.src = 'https://www.youtube-nocookie.com/embed/' + f.dataset.ubzFilm + '?autoplay=1&rel=0&playsinline=1';
      ifr.title = still.getAttribute('aria-label') || 'Film';
      ifr.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      ifr.allowFullscreen = true;
      box.appendChild(ifr);
      still.replaceWith(box);
    }, {once: true});
  });

  /* the turn: scroll drives two full turns, front photo facing us, back photo when she has her back to us */
  const turn = $('[data-ubz-turn]');
  if (turn && !matchMedia('(prefers-reduced-motion: reduce)').matches){
    const fig = turn.querySelector('[data-ubz-fig]'), front = fig.querySelector('.f'), back = fig.querySelector('.b');
    const shadow = turn.querySelector('[data-ubz-shadow]'), lines = [...turn.querySelectorAll('[data-ubz-line]')];
    const ease = t => t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    let tick = false;
    const draw = () => {
      tick = false;
      const r = turn.getBoundingClientRect(), run = r.height - innerHeight;
      const p = Math.min(1, Math.max(0, -r.top / (run > 0 ? run : 1)));
      const k = ease(Math.min(1, Math.max(0, (p - .3) / .5)));      /* she turns between 30% and 80% of the scroll */
      const a = k * Math.PI * 4, c = Math.cos(a), lift = Math.sin(k * Math.PI) * 10;
      const sx = .32 + .68 * Math.abs(c);
      fig.style.transform = 'translateX(-50%) translateY(' + (-lift) + 'px) scaleX(' + sx.toFixed(3) + ')';
      front.style.opacity = c >= 0 ? 1 : 0; back.style.opacity = c >= 0 ? 0 : 1;
      shadow.style.transform = 'translateX(-50%) scaleX(' + (.55 + .45 * sx).toFixed(3) + ')';
      turn.style.setProperty('--light', (.45 + .55 * Math.min(1, p * 2)).toFixed(3));
      turn.style.setProperty('--ring', (1 - k).toFixed(3));
      const n = Math.min(lines.length - 1, Math.floor(p * lines.length));
      lines.forEach((l, i) => l.classList.toggle('on', i === n));
    };
    addEventListener('scroll', () => { if (!tick){ tick = true; requestAnimationFrame(draw); } }, {passive: true});
    addEventListener('resize', draw);
    draw();
  }

  /* reveal on view */
  const reveal = $$('[data-ubz-reveal]');
  if ('IntersectionObserver' in window){
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }), {threshold: .2});
    reveal.forEach(el => io.observe(el));
  } else reveal.forEach(el => el.classList.add('in'));

  /* gallery fit: the whole piece shows in the square, the empty sides take the photo's own background colour */
  const edge = img => {
    try {
      const c = document.createElement('canvas'); c.width = c.height = 32;
      const x = c.getContext('2d'); x.drawImage(img, 0, 0, 32, 32);
      const d = x.getImageData(0, 0, 32, 32).data, wide = img.naturalWidth > img.naturalHeight;
      let r = 0, g = 0, b = 0, n = 0;
      for (let k = 0; k < 32; k++) for (const e of [0, 31]) { const i = (wide ? e * 32 + k : k * 32 + e) * 4; r += d[i]; g += d[i + 1]; b += d[i + 2]; n++; }
      return `rgb(${r / n | 0},${g / n | 0},${b / n | 0})`;
    } catch (e) { return ''; }
  };
  slides.forEach((s, k) => {
    const img = s.querySelector('img'); if (!img) return;
    const go = () => { if (Math.abs(img.naturalWidth / img.naturalHeight - 1) < .02) return; const c = edge(img); if (c) { s.style.setProperty('--fill', c); if (thumbs[k]) thumbs[k].style.setProperty('--fill', c); } };
    img.complete && img.naturalWidth ? go() : img.addEventListener('load', go, {once: true});
  });
  thumbs.forEach(t => { const i = t.querySelector('img'); if (!i) return; const u = new URL(i.src, location.href); if (u.searchParams.has('crop')) { u.searchParams.delete('crop'); u.searchParams.delete('height'); i.src = u.href; } });
})();
